export default __webpack_public_path__ + "static/media/DOCKS.3128604d.webp";